<template>
  <div class="mit-reservation-activity-list pa-5">
    <BaseMitLoading :show="loading" :fullscreen="false"/>
    <v-snackbar top :color="status.color" min-width="0" v-model="status.display" :timeout="status.timeout">
            <b>{{ status.message }}</b>
        </v-snackbar>
    <v-card flat>
        <!-- <BaseMitUrlParams ref="mitUrlParamsRef" v-on:changed="updateFilters"/> -->
          <v-btn v-if="dateRange" @click="dateRange = null; updateDateRange(null)" class="ma-1 mr-2" color="primary">{{ dateRange }}<v-icon class="ml-2">mdi-close-circle</v-icon></v-btn>
          <v-menu v-if="dateRange == null" bottom >
              <template v-slot:activator="{ on, attrs }">
                  <v-btn class="ma-1 mr-1" color="primary" outlined text v-bind="attrs" v-on="on">Date Range<v-icon>mdi-menu-down</v-icon></v-btn>
              </template>
              <v-list>
                  <v-list-item @click="dateRange = 'Next 1 Week'; updateDateRange(1)" link>
                      <v-list-item-title>1 Week</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="dateRange = 'Next 2 Weeks'; updateDateRange(2)" link>
                      <v-list-item-title>2 Weeks</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="dateRange = 'Next 4 Weeks'; updateDateRange(4)" link>
                      <v-list-item-title>4 Weeks</v-list-item-title>
                  </v-list-item>
                  <v-divider></v-divider>
                  <v-list-item @click="dateRange = 'Past 2 Weeks'; updateDateRange(-2)" link>
                      <v-list-item-title>Past 2 Weeks</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="dateRange = 'Past 4 Weeks'; updateDateRange(-4)" link>
                      <v-list-item-title>Past 4 Weeks</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="dateRange = 'Past 8 Weeks'; updateDateRange(-8)" link>
                      <v-list-item-title>Past 8 Weeks</v-list-item-title>
                  </v-list-item>
              </v-list>
          </v-menu>
          <v-btn v-if="setupStateValue" @click="setupStateValue = null; updateState(null)" class="ma-1 mr-2" color="primary">{{ setupStateValue }}<v-icon class="ml-2">mdi-close-circle</v-icon></v-btn>
          <v-menu v-if="setupStateValue == null" bottom >
              <template v-slot:activator="{ on, attrs }">
                  <v-btn class="ma-1 mr-1" color="primary" outlined text v-bind="attrs" v-on="on">Setup State<v-icon>mdi-menu-down</v-icon></v-btn>
              </template>
              <v-list>
                  <v-list-item @click="setupStateValue = setupStateDict.requested.name; updateState(setupStateDict.requested.val)" link>
                      <v-list-item-title>{{ setupStateDict.requested.name }}</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="setupStateValue = setupStateDict.completed.name; updateState(setupStateDict.completed.val)" link>
                      <v-list-item-title>{{ setupStateDict.completed.name }}</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="setupStateValue = setupStateDict.contact.name; updateState(setupStateDict.contact.val)" link>
                      <v-list-item-title>{{ setupStateDict.contact.name }}</v-list-item-title>
                  </v-list-item>
              </v-list>
          </v-menu>
    </v-card>
    <!-- <MitReservationActivityList :reservationActivity="activity" showDetails/> -->
    
    <BaseMitDataTable
      title="Setup Requests"
      :page="paging.page"
      :pageSize="paging.pageSize"
      :totalItems="paging.totalItems"
      :pageSizes="{itemsPerPageOptions:[10, 20, 50, 100]}"
      :editable="false"
      :headers="headers"
      :items="reservations"
      :showExpanded="true" 
      itemKey="id"
      :singleExpanded="false"
      @pagination="updatePagination"
    >
        <template v-slot:item.setupState="{ item }">
          <!-- <v-btn class="" x-small color="primary" elevation="0">{{item.setupState}}</v-btn> -->
          <v-chip small :color="statusColor(item)">{{item.setupState}}</v-chip>
          <!-- <span style="background-color: green;">{{item.setupState}}</span> -->
        </template>
        <template v-slot:item.complete="{ item }">
          <v-btn class="" x-small text outlined color="primary" elevation="0" @click="updateReservation(item.uniqueId, setupStateDict.completed.val)">Complete</v-btn>
        </template>
        <template v-slot:item.contact="{ item }">
          <v-btn class="" x-small text outlined color="red" elevation="0" @click="updateReservation(item.uniqueId, setupStateDict.contact.val)">Contact TIG</v-btn>
        </template>
        <template v-slot:item.setupActions="{ item }">
          <span v-if="item.setupState !== setupStateDict.requested.val">
            <v-btn class="" x-small text outlined elevation="0" @click="updateReservation(item.uniqueId, setupStateDict.requested.val)">Reopen</v-btn>
          </span>
          <div v-else>
              <v-btn class="mr-3" x-small text outlined color="primary" elevation="0" @click="updateReservation(item.uniqueId, setupStateDict.completed.val)">Complete</v-btn>
              <v-btn class="" x-small text outlined color="red" elevation="0" @click="updateReservation(item.uniqueId, setupStateDict.contact.val)">Contact TIG</v-btn>
          </div>
          
        </template>
        <template v-slot:item.setToRt="{ item }">
          <v-btn class="" title="Send this request to the calendar RT system" small text outlined elevation="0" @click="sendToTig(item)"><v-icon>mdi-email-arrow-right</v-icon></v-btn>
        </template>
        
        <template v-slot:expanded-item="{ item }">
            <!-- expand across all the columns, so use the header length -->
            <td class="pa-1" :colspan="headers.length+1">
              <BaseMitReservationReadOnly :reservation="item" showDetails/>
            </td>
        </template>
    </BaseMitDataTable>
  </div>
</template>

<script>
import moment from 'moment';

import MitReservationService from '../../base/services/BaseMitReserveService.js';
import MitReservationSetupService from '../services/MitReservationSetupService.js';
import BaseMitDataTable from '../../base/components/BaseMitDataTable.vue';
import BaseMitUrlParams from '../../base/components/BaseMitUrlParams.vue';
import BaseMitLoading from '../../base/components/BaseMitLoading.vue';
import BaseMitReservationReadOnly from '../../base/components/reserve/BaseMitReservationReadOnly.vue';

export default {
  name: 'MitReservationSetup',
  components: {
    BaseMitLoading,
    BaseMitDataTable,
    BaseMitUrlParams,
    BaseMitReservationReadOnly
  },
  props: {
  },
  data: function() {
    return {
      status:{
          display:false,
          timeout:3000,
          message:'Saved!',
          color:'primary'
        },
      dateRange:null,
      setupStateDict:MitReservationService.getSetupStateDict(),
      setupStateValue:null,
      loading:false,
      options:{},
      paging:{
        page:1,
        pageSize:5,
        totalItems:0
      },
      filterableHeaders:[ //moment().local().format("hh:mm A")
        {text: 'CSAIL ID',value: 'userId', default:'', hint:'The exact csail id'},
        {text: 'Space',value: 'mitId', default:'', hint:'The exact space id'},
        {text: 'Status',value: 'status', default:'', hint:'The exact type "pending", "completed", "contact"'},
        {text: 'Unique Id',value: 'uniqueId', default:'', hint:'The exact unique id of the reservation'},
        {text: 'Unique Id Series',value: 'recurringUniqueId', default:'', hint:'Enter the recurring unique id, will display edits users made to individual events in this recurring series'},
        {text: 'Start Date',value: 'startDt', default:this.getDateStringLocalNow(), hint:'Create Date >=. Format is "YYYY-MM-DD HH:mm:ss" 24h local time.'},
        {text: 'End Date',value: 'endDt', default:this.getDateStringLocalNow(), hint:'End Date <=. Format is "YYYY-MM-DD HH:mm:ss" 24h local time.'},
      ],
      headers:[
          {text: 'Name',sortable: false,value: 'name'},
          {text: 'Space',sortable: false,value: 'mitId', width:'100px'},
          {text: 'Start Time',sortable: false,value: 'startDateTimeDisplay1', width:'230px'},
          {text: 'Setup',sortable: false,value: 'setupState'},
          // {text: 'Setup Request',sortable: false,value: 'setupDescription', width:'100px'},
          {text: 'Actions',sortable: false,value: 'setupActions', width:'300px'},
          {text: 'Send To OPS Queue',sortable: false,value: 'setToRt'},
          // {text: '',sortable: false,value: 'complete', width:'100px'},
          // {text: '',sortable: false,value: 'contact', width:'100px'}
        ],
      reservations:[],
    }
  },
  created() {
  },
  mounted(){
    this.refreshData(this.paging, this.options);
  },
  methods : {
    statusColor(reservation) {

      if(reservation.setupState === this.setupStateDict.completed.val)
        return 'primary lighten-1';
      if(reservation.setupState === this.setupStateDict.contact.val)
        return 'red lighten-2';

      //default requested
      return 'grey lighten-2';
    },
    getDateStringLocalNow(){
      return moment().local().format('YYYY-MM-DD HH:mm:ss').toString();
    },
    updatePagination (pagination) {
      //setting this into the control will trigger this event so initiall don't bother refreshing
      //if the items length is zero, we have no data yet.
      if(pagination.itemsLength > 0){
        this.paging.page = pagination.page;
        this.paging.pageSize = pagination.itemsPerPage;

        this.refreshData(this.paging, this.options);
      }

    },
    updateReservation(uniqueId, state){
      this.loading = true;
      MitReservationSetupService.updateReservationSetupStatus(uniqueId, state)
        .then((data) => {
          this.loading = false;
          // this.status.message = 'Saved!',
          // this.status.color = 'primary'
          // this.status.display = true;

          this.refreshData(this.paging, this.options);
        })
        .catch((error) => {
          this.loading = false;
          this.status.message = 'An error occurred trying to update reservation '+uniqueId;
          this.status.display = true;
          this.status.color = 'red';
          console.log('An error occurred trying to set setup state', error);
        });
    },
    refreshData(pagination, options){
      this.loading = true;
      MitReservationSetupService.getReservationsNeedingSetup(pagination, options)
        .then((data) => {
          this.loading = false;

          this.reservations = data.reservations;
          this.paging.totalItems = data.total;
        })
        .catch((error) => {
          this.loading = false;
          console.log('An error occurred trying to get setup list', error);
        });
    },
    updateState(val){
      if(val){
        this.options.state = val;
      }
      else{
        delete this.options.state;
      }
     
      this.refreshData(this.paging, this.options);
    },
    sendToTig(reservation){
      this.loading = true;
      MitReservationSetupService.sendUpdateRequestToTIG(reservation.uniqueId)
        .then((data) => {
          this.loading = false;
          this.status.message = 'Sent!',
          this.status.color = 'primary'
          this.status.display = true;

          this.refreshData(this.paging, this.options);
        })
        .catch((error) => {
          this.loading = false;
          this.status.message = 'An error occurred trying to email to ops ';
          this.status.display = true;
          this.status.color = 'red';
          console.log('An error occurred trying to set setup state', error, reservation);
        });

    },
    updateDateRange(val){
      if(val){
        let start;
        let end;
        if(val > 0){
          start = moment.utc().startOf('day');
          end = moment.utc(start).add(val, 'weeks').endOf('day');
        }
        else{
          end = moment.utc().startOf('day');
          start = moment.utc(end).subtract(Math.abs(val), 'weeks').endOf('day');
        }

        this.options.start = start.format('YYYY-MM-DD hh:mm A');
        this.options.end = end.format('YYYY-MM-DD hh:mm A');
      }
      else{
        delete this.options.start;
        delete this.options.end;
      }
     
      this.refreshData(this.paging, this.options);
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
